import { Box, Skeleton, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import Image from 'next/image';
import getConfig from 'next/config';
import { useTheme } from '@mui/material/styles';
import styles from './styles';
import StyledCardContent from './CardContent.styled';
import fetchImgData from '../../../util/base64Generator';

const { publicRuntimeConfig } = getConfig();

const EirSingleCardimage = ({
  preTitle,
  title,
  loading,
  // headerImage = [],
  offerSelected,
  switchTheme,
  color,
  // cardHovered = false,
  singleTariffHeaderImage = [],
  singleHeaderImgDescription,
}) => {
  const theme = useTheme();
  const [base64Data, setBase64Data] = useState('');
  const [base64Error, setBase64error] = useState(false);
  const [dataFetched, setdataFetched] = useState(false);

  const getBase64ImgData = async () => {
    const { data } = await fetchImgData(
      `${publicRuntimeConfig.NEXT_PUBLIC_STRAPI}${singleTariffHeaderImage[0]}.base64`
    );
    if (data) {
      setBase64Data(data);
      setdataFetched(true);
    } else {
      setdataFetched(true);
      setBase64error(true);
    }
  };

  useEffect(() => {
    if (singleTariffHeaderImage.length > 0 && !loading) {
      getBase64ImgData();
    } else if (singleTariffHeaderImage.length === 0 && !loading) {
      setdataFetched(true);
    }
  }, [singleTariffHeaderImage[0], loading]);

  return (
    <StyledCardContent
      sx={
        singleTariffHeaderImage[0]
          ? [styles(theme).singleContainerWithImage]
          : styles(theme).singleContainer
      }
    >
      {dataFetched ? (
        <>
          {singleTariffHeaderImage[0] && (
            <Box style={{ ...styles(theme)?.SingleTitleContainerWithImage, position: 'relative' }}>
              <Image
                src={`${publicRuntimeConfig.NEXT_PUBLIC_STRAPI_SERVER}${singleTariffHeaderImage[0]}`}
                style={{
                  objectFit: 'cover',
                  // This is commented out since we don't need hover effect currently, once hover is required we can uncomment
                  // objectPosition: cardHovered || offerSelected ? 'right center' : 'left center',
                  objectPosition: 'center',
                }}
                alt={
                  singleHeaderImgDescription &&
                  singleHeaderImgDescription.length &&
                  singleHeaderImgDescription[0]
                }
                placeholder={base64Error ? 'empty' : 'blur'}
                layout='fill'
                blurDataURL={!base64Error && `${base64Data}`}
              />
            </Box>
          )}
          {!singleTariffHeaderImage[0] && (
            <Box
              sx={[
                styles(theme)?.singleTitleContainer,
                {
                  ...(offerSelected === false &&
                    (switchTheme === false
                      ? { backgroundColor: theme?.palette[color].offerMain }
                      : { backgroundColor: theme?.palette[color].OfferSelected })),
                  ...(offerSelected === true &&
                    (switchTheme === false
                      ? { backgroundColor: theme?.palette[color].OfferSelected }
                      : { backgroundColor: theme?.palette[color].offerMain })),
                },
              ]}
            >
              {preTitle && !singleTariffHeaderImage[0] && (
                <Typography variant='h5' sx={styles(theme)?.singlePreTitle}>
                  {preTitle}
                </Typography>
              )}
              {title && !singleTariffHeaderImage[0] && (
                <Typography variant='h2' sx={styles(theme)?.singleTitle}>
                  {title}
                </Typography>
              )}
            </Box>
          )}
        </>
      ) : (
        <Skeleton variant='rectangular' width='100%'>
          <Box style={{ paddingTop: '85%' }} />
        </Skeleton>
      )}
    </StyledCardContent>
  );
};
export default EirSingleCardimage;
